const SCROLL_BLOCK_CLASS = 'scroll-block';

// tslint:disable-next-line no-unnecessary-class
export class ScrollBlock {
    // tslint:disable-next-line function-name
    public static enable(): void {
        document.documentElement.style.top = `-${document.documentElement.scrollTop}px`;
        document.documentElement.classList.add(SCROLL_BLOCK_CLASS);
    }

    // tslint:disable-next-line function-name
    public static disable(): void {
        const scrollTop: number = parseInt(
            document.documentElement.style.top,
            10,
        );
        document.documentElement.classList.remove(SCROLL_BLOCK_CLASS);
        document.documentElement.style.top = '';
        document.documentElement.scrollTop = Math.abs(scrollTop);
    }
}
